import React, { useState, useEffect } from "react";
import CustomSerialNumberRangePanelComponent from "./customSerialNumberRangePanel.component";

function CustomSerialNumberRangePanelContainer({
  formik,
  disabled,
  checkSNAvailability,
  updateQuantity,
  isSNexceedRange,
}) {
  const [isSameRange, setIsSameRange] = useState(false);
  const [isExceedLimit, setIsExceedLimit] = useState(false);

  useEffect(() => {
    setIsSameRange(false);
  }, [formik.values.format]);

  const onCustomRangeChange = (event, name) => {
    formik.setFieldValue(name, event.target.value);

    const format = formik.values.format.split(",");
    const length = parseInt(format[1], 10);

    setIsExceedLimit(name && name.toString().length !== length);
    setIsSameRange(false);
  };

  const submit = () => {
    const range = formik.getFieldProps("generateRanges").value;
    let sameRange = false;

    const total = range.reduce((a, b) => {
      if (!Number.isNaN(b.start) && !Number.isNaN(b.end)) {
        const start = Number(b.start);
        const end = Number(b.end);
        return a + (end - start + 1);
      }
      return a;
    }, 0);
    updateQuantity(total);

    const tempRange = [];
    range.forEach((number, index) => {
      const start = Number(number.start);
      const end = Number(number.end);

      const overlap = range.findIndex((r, i) => {
        if (index !== i) {
          return (
            (r.start <= start && r.end >= end) ||
            (r.start >= start && r.start <= end) ||
            (r.end >= start && r.end <= end)
          );
        }
        return false;
      });

      if (overlap >= 0) {
        sameRange = true;
      }

      const format = formik.values.format.split(",");
      const length = format[1];

      tempRange.push({
        start: start.toString().padStart(length, "0"),
        end: end.toString().padStart(length, "0"),
      });
    });
    formik.setFieldValue("generateRanges", tempRange);

    if (!sameRange) {
      const [prefix, length, postfix] = formik.values.format.split(",");
      const serialNumberGenRanges = formik.values.generateRanges.map((r) => ({
        start: prefix + r.start.toString().padStart(length, "0") + postfix,
        end: prefix + r.end.toString().padStart(length, "0") + postfix,
      }));

      checkSNAvailability(serialNumberGenRanges);
      // value check for submit assign serial number
      formik.setFieldValue("isSerialNumber", true);
      setIsSameRange(sameRange);
    } else {
      setIsSameRange(sameRange);
    }
  };

  return (
    <CustomSerialNumberRangePanelComponent
      formik={formik}
      onCustomRangeChange={onCustomRangeChange}
      isSameRange={isSameRange}
      isExceedLimit={isExceedLimit}
      isSNexceedRange={isSNexceedRange}
      isInputDisable={disabled}
      submit={submit}
    />
  );
}

export default CustomSerialNumberRangePanelContainer;
